import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

export const getMemberProfile = (payload) =>
  connectApi({ method: "POST", url: baseURL.getMemberProfile, payload });

export const editMemberProfile = (payload) =>
  connectApi({ method: "POST", url: baseURL.editMemberProfile, payload });

export const getRegisteredProduct = (payload) =>
  connectApi({ method: "POST", url: baseURL.getRegisteredProduct, payload });

export const getRedeemHistory = (payload) =>
  connectApi({ method: "POST", url: baseURL.getRedeemHistory, payload });

export const getPointHistory = (payload) =>
  connectApi({ method: "POST", url: baseURL.getPointHistory, payload });
